/**
 * Percentages — §5.6, pt-BR.
 *
 * The platform's percentages are stored as **whole numbers** (`desconto_aws: 12`
 * means twelve percent), not as fractions of one. `Intl` expects the fraction, so
 * the division happens here, once — rather than in each screen, where half of them
 * would eventually forget and render `1.200%`.
 */

/** `12,5%` — from a whole-number percentage, which is how §7 stores them. */
export function formatarPercentual(percentual: number, casas = 1): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: casas,
  }).format(percentual / 100)
}

/**
 * A variation, with its sign — for "economia vs. mês anterior" style figures.
 * Positive gets an explicit `+`, because a bare number next to a negative one
 * reads as neutral rather than as growth.
 */
export function formatarVariacao(percentual: number, casas = 1): string {
  const formatado = formatarPercentual(Math.abs(percentual), casas)
  if (percentual > 0) return `+${formatado}`
  if (percentual < 0) return `−${formatado}`
  return formatado
}
